<div class="col-auto my-2 has-validation">
  <label
    class="form-label"
    [class.required]="hasRequiredValidator()"
    for="{{ inputFormControlName() }}"
  >
    {{ label() | translate }}
  </label>
  <quill-editor
    class="form-control"
    id="{{ inputFormControlName() }}"
    [formControl]="inputFormControl()"
    [attr.required]="hasRequiredValidator()"
    [placeholder]="placeholder() | translate"
    [readOnly]="isDisabled()"
    [ngClass]="{ 'is-disabled': isDisabled() }"
  ></quill-editor>
  @if (maxLength() !== undefined && inputFormControl().value !== null) {
    <div class="text-end mt-1 text-600">
      <small>{{ inputFormControl().value.length }} / {{ maxLength() }}</small>
    </div>
  }
  @if (inputFormControl().touched && inputFormControl().invalid) {
    <div class="feedback">
      <div *ngIf="errorKeys().length > 0">
        {{ getErrorMessage(errorKeys()[0]) | translate }}
      </div>
    </div>
  } @else if (leaveSpaceForValidation()) {
    <div class="placeholder-feedback"></div>
  }
</div>
